import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { salesData } from '../data/salesData';
import WhoHero from '../Components/who/WhoHero';
import { ChevronRight } from 'lucide-react';

const servicesCard = [
  {
    name: "ServiceNow Consulting in Mumbai",
    slug: "/location/leverage-serviceNow-consulting-in-mumbai",
    text: "Partner with Mobikode's ServiceNow experts in Mumbai to simplify operations, improve team productivity, automate workflows, and drive lasting business growth.",
    image: "/assets/service-detail/img1.png"
  },
  {
    name: "ServiceNow Consulting in Bangalore",
    slug: "/location/leverage-serviceNow-consulting-in-bangalore",
    text: "Empower your tech hub operations in Bangalore with customized ServiceNow solutions to streamline IT workflows and boost enterprise scalability.",
    image: "/assets/service-detail/img2.png"
  },
  {
    name: "ServiceNow Consulting in Pune",
    slug: "/location/leverage-serviceNow-consulting-in-pune",
    text: "Transform business processes in Pune through scalable ServiceNow integration, end-to-end automation, and efficient service delivery.",
    image: "/assets/service-detail/img3.png"
  },
  {
    name: "ServiceNow Consulting in Chennai",
    slug: "/location/leverage-serviceNow-consulting-in-chennai",
    text: "Empower Chennai's industrial and IT enterprises with Mobikode's expert ServiceNow consulting to optimize workflows and boost operational efficiency.",
    image: "/assets/service-detail/img4.png"
  },
  {
    name: "ServiceNow Consulting in Gurgaon",
    slug: "/location/leverage-serviceNow-consulting-in-gurgaon",
    text: "Accelerate digital transformation for corporate leaders in Gurgaon with scalable ServiceNow ITSM, automation, and tailored enterprise solutions.",
    image: "/assets/service-detail/img5.png"
  },
  {
    name: "ServiceNow Consulting in Hyderabad",
    slug: "/location/leverage-serviceNow-consulting-in-hyderabad",
    text: "Accelerate digital transformation in Hyderabad with expert ServiceNow consulting, ITSM optimization, and continuous service support.",
    image: "/assets/service-detail/img6.png"
  },
  {
    name: "ServiceNow Consulting in Delhi",
    slug: "/location/leverage-serviceNow-consulting-in-delhi",
    text: "Drive seamless digital workflows and administrative agility for enterprises in Delhi with strategic ServiceNow implementation.",
    image: "/assets/service-detail/img7.png"
  },
  {
    name: "ServiceNow Consulting in Gurugram",
    slug: "/location/leverage-serviceNow-consulting-in-gurugram",
    text: "Optimize corporate operations in Gurugram with tailored ServiceNow ITAM, CSM, and automation strategies designed for high growth.",
    image: "/assets/service-detail/img8.png"
  },
  {
    name: "ServiceNow Consulting in Belgium",
    slug: "/location/leverage-serviceNow-consulting-in-belgium",
    text: "Empower European enterprises in Belgium with robust ServiceNow architectures that enhance operational governance and compliance.",
    image: "/assets/service-detail/img9.jpg"
  },
  {
    name: "ServiceNow Consulting in Croatia",
    slug: "/location/leverage-serviceNow-consulting-in-croatia",
    text: "Modernize IT management and service delivery for businesses across Croatia through specialized ServiceNow consulting.",
    image: "/assets/service-detail/img10.png"
  },
  {
    name: "ServiceNow Consulting in Denmark",
    slug: "/location/leverage-serviceNow-consulting-in-denmark",
    text: "Implement agile, sustainable, and modern ServiceNow solutions tailored for Denmark's fast-evolving business landscape.",
    image: "/assets/service-detail/img11.png"
  },
  {
    name: "ServiceNow Consulting in Finland",
    slug: "/location/leverage-serviceNow-consulting-in-finland",
    text: "Leverage advanced ServiceNow automation and cloud management solutions to boost productivity for Finnish enterprises.",
    image: "/assets/service-detail/img12.png"
  },
  {
    name: "ServiceNow Consulting in France",
    slug: "/location/leverage-serviceNow-consulting-in-france",
    text: "Transform enterprise workflows and client management across France with custom ServiceNow deployment strategies.",
    image: "/assets/service-detail/img13.png"
  },
  {
    name: "ServiceNow Consulting in Germany",
    slug: "/location/leverage-serviceNow-consulting-in-germany",
    text: "Drive industrial-grade precision and digital workflow maturity for German enterprises using cutting-edge ServiceNow platforms.",
    image: "/assets/service-detail/img14.png"
  },
  {
    name: "ServiceNow Consulting in Greece",
    slug: "/location/leverage-serviceNow-consulting-in-greece",
    text: "Enhance operational speed and customer service capability across organizations in Greece with expert ServiceNow guidance.",
    image: "/assets/service-detail/img15.png"
  },
  {
    name: "ServiceNow Consulting in Hungary",
    slug: "/location/leverage-serviceNow-consulting-in-hungary",
    text: "Optimize IT services and workflow automation for growing businesses in Hungary through tailored ServiceNow roadmaps.",
    image: "/assets/service-detail/img16.png"
  },
  {
    name: "ServiceNow Consulting in Italy",
    slug: "/location/leverage-serviceNow-consulting-in-italy",
    text: "Streamline service operations and elevate employee experience for Italian companies with ServiceNow digital transformation.",
    image: "/assets/service-detail/img17.png"
  },
  {
    name: "ServiceNow Consulting in Luxembourg",
    slug: "/location/leverage-serviceNow-consulting-in-luxembourg",
    text: "Deliver secure, high-compliance ServiceNow consulting catered specifically for financial and enterprise sectors in Luxembourg.",
    image: "/assets/service-detail/img18.png"
  },
  {
    name: "ServiceNow Consulting in Monaco",
    slug: "/location/leverage-serviceNow-consulting-in-monaco",
    text: "Deliver premium, high-efficiency ServiceNow operations tailored for elite enterprise requirements in Monaco.",
    image: "/assets/service-detail/img19.png"
  },
  {
    name: "ServiceNow Consulting in Netherlands",
    slug: "/location/leverage-serviceNow-consulting-in-netherlands",
    text: "Build resilient digital ecosystem infrastructure and unified service management for Dutch enterprises.",
    image: "/assets/service-detail/item2.png"
  },
  {
    name: "ServiceNow Consulting in Spain",
    slug: "/location/leverage-serviceNow-consulting-in-spain",
    text: "Drive workflow efficiency and seamless business operations across Spain with custom ServiceNow implementations.",
    image: "/assets/service-detail/item3.png"
  },
  {
    name: "ServiceNow Consulting in Sweden",
    slug: "/location/leverage-serviceNow-consulting-in-sweden",
    text: "Empower Nordic enterprises in Sweden with scalable, automated ServiceNow solutions designed for operational excellence.",
    image: "/assets/service-detail/item4.png"
  },
  {
    name: "ServiceNow Consulting in Switzerland",
    slug: "/location/leverage-serviceNow-consulting-in-switzerland",
    text: "Deploy Swiss-precision ServiceNow consulting ensuring data security, workflow efficiency, and seamless operational continuity.",
    image: "/assets/v/item1.png"
  },
  {
    name: "ServiceNow Consulting in Dubai",
    slug: "/location/leverage-serviceNow-consulting-in-dubai",
    text: "Power Dubai’s futuristic digital enterprise vision with enterprise-grade ServiceNow automation and ITSM solutions.",
    image: "/assets/v/item9.png"
  },
  {
    name: "ServiceNow Consulting in Sharjah",
    slug: "/location/leverage-serviceNow-consulting-in-sharjah",
    text: "Optimize regional workflows and accelerate business agility in Sharjah through modern ServiceNow integrations.",
    image: "/assets/v/item3.png"
  },
  {
    name: "ServiceNow Consulting in Abu Dhabi",
    slug: "/location/leverage-serviceNow-consulting-in-abu-dhabi",
    text: "Scale enterprise operations in Abu Dhabi with tailored ServiceNow solutions designed for public and corporate sectors.",
    image: "/assets/v/item4.png"
  },
  {
    name: "ServiceNow Consulting in Saudi Arabia",
    slug: "/location/leverage-serviceNow-consulting-in-saudi-arabia",
    text: "Support Saudi Arabia's Vision 2030 digital goals with enterprise-scale ServiceNow consulting and workflow integration.",
    image: "/assets/v/item5.png"
  },
  {
    name: "ServiceNow Consulting in New York",
    slug: "/location/leverage-serviceNow-consulting-in-new-york",
    text: "Empower fast-paced businesses in New York with high-performance ServiceNow architecture and automated service management.",
    image: "/assets/v/item6.png"
  },
  {
    name: "ServiceNow Consulting in California",
    slug: "/location/leverage-serviceNow-consulting-in-california",
    text: "Fuel Silicon Valley innovation with agile ServiceNow implementation, automated enterprise workflows, and custom app dev.",
    image: "/assets/v/item7.jpg"
  },
  {
    name: "ServiceNow Consulting in Melbourne",
    slug: "/location/leverage-serviceNow-consulting-in-melbourne",
    text: "Drive operational agility and exceptional service delivery for Australian enterprises in Melbourne with ServiceNow.",
    image: "/assets/v/item8.jpg"
  },
  {
    name: "ServiceNow Consulting in Washington DC",
    slug: "/location/leverage-serviceNow-consulting-in-washington-dc",
    text: "Deliver mission-critical ServiceNow architecture, compliance-ready workflows, and robust service delivery for organizations in Washington DC.",
    image: "/assets/v/item1.png"
  },
  {
    name: "ServiceNow Consulting in Dallas",
    slug: "/location/leverage-serviceNow-consulting-in-dallas",
    text: "Drive business agility and digital transformation in Dallas through scalable ServiceNow automation, ITSM, and enterprise system integrations.",
    image: "/assets/v/item2.png"
  },
  {
    name: "ServiceNow Consulting in Houston",
    slug: "/location/leverage-serviceNow-consulting-in-houston",
    text: "Modernize operational pipelines and enterprise service frameworks in Houston with tailored ServiceNow deployment and support solutions.",
    image: "/assets/v/item3.png"
  },
  {
    name: "ServiceNow Consulting in Charlotte",
    slug: "/location/leverage-serviceNow-consulting-in-charlotte",
    text: "Power enterprise agility, compliance, and automated service management for growing corporate and financial sectors in Charlotte.",
    image: "/assets/v/item4.png"
  },
  {
    name: "ServiceNow Consulting in Chicago",
    slug: "/location/leverage-serviceNow-consulting-in-chicago",
    text: "Empower Chicago enterprises to streamline operations, automate routine processes, and elevate employee experience with ServiceNow.",
    image: "/assets/v/item5.png"
  },
  {
    name: "ServiceNow Consulting in Atlanta",
    slug: "/location/leverage-serviceNow-consulting-in-atlanta",
    text: "Accelerate digital growth and enterprise scalability across Atlanta's dynamic business ecosystem with end-to-end ServiceNow solutions.",
    image: "/assets/v/item6.png"
  },
  {
    name: "ServiceNow Consulting in Phoenix",
    slug: "/location/leverage-serviceNow-consulting-in-phoenix",
    text: "Streamline service workflows and drive cross-functional productivity for expanding enterprises in Phoenix with custom ServiceNow roadmaps.",
    image: "/assets/v/item7.jpg"
  },
  {
    name: "ServiceNow Consulting in Boston",
    slug: "/location/leverage-serviceNow-consulting-in-boston",
    text: "Fuel enterprise innovation in Boston with modern ServiceNow implementations designed to unify workflows and optimize service management.",
    image: "/assets/v/item8.jpg"
  },
  {
    name: "ServiceNow Consulting in Austin",
    slug: "/location/leverage-serviceNow-consulting-in-austin",
    text: "Supercharge tech operations and scale business models in Austin with modern ServiceNow app development, ITSM, and cloud workflows.",
    image: "/assets/v/item9.png"
  },
  {
    name: "ServiceNow Consulting in Philadelphia",
    slug: "/location/leverage-serviceNow-consulting-in-philadelphia",
    text: "Optimize service workflows, boost platform performance, and drive enterprise resilience across organizations in Philadelphia.",
    image: "/assets/service-detail/item2.png"
  },
  {
    name: "ServiceNow Consulting in Detroit",
    slug: "/location/leverage-serviceNow-consulting-in-detroit",
    text: "Modernize industrial and enterprise operations in Detroit with automated ServiceNow workflows, IT asset management, and seamless integrations.",
    image: "/assets/service-detail/item3.png"
  },
  {
    name: "ServiceNow Consulting in Qatar",
    slug: "/location/leverage-serviceNow-consulting-in-qatar",
    text: "Transform business processes in Qatar through smart ServiceNow implementations, custom automation, and end-to-end platform support.",
    image: "/assets/service-detail/item4.png"
  },
  {
    name: "ServiceNow Consulting in Kuwait",
    slug: "/location/leverage-serviceNow-consulting-in-kuwait",
    text: "Simplify operations, automate tasks, and drive lasting business growth in Kuwait with Mobikode's expert ServiceNow consulting services.",
    image: "/assets/service-detail/img1.png"
  }
];

const ServiceCard = ({ service }) => {
  return (
    <motion.div
      initial="initial"
      whileHover="hover"
      animate="initial"
      className="relative h-[300px] lg:h-[320px] overflow-hidden cursor-pointer group shadow-lg"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={service.image || service.bgImage || "/assets/service-detail/img1.png"}
          alt={service.title || service.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/70 transition-opacity duration-300 group-hover:bg-black/70" />
      </div>

      <div className="relative z-20 h-full flex flex-col p-[20px] sm:p-[30px]">

        <div className="relative z-20 h-[56px] sm:h-[60px] flex items-start">
          <h3 className="text-white font-sora font-[600] text-[18px] lg:text-[20px] leading-[1.3] line-clamp-2">
            {service.title || service.name}
          </h3>
        </div>

        <div className="flex-1 flex items-start pt-[15px] sm:pt-[20px] relative overflow-hidden">
          <motion.p
            className="text-white/90 font-sora text-[14px] sm:text-[16px] leading-[22px] sm:leading-[26px]"
            variants={{
              initial: { x: 50, opacity: 0 },
              hover: { x: 0, opacity: 1 }
            }}
            transition={{ duration: 0.4, ease: "easeOut", delay: 0.1 }}
          >
            {service.text}
          </motion.p>
        </div>

        {/* Bottom CTA / View Details */}
        <motion.div
          className="flex items-center justify-end mt-auto"
          transition={{ duration: 0.4, delay: 0.1 }}
        >
          <div className="flex items-center gap-2 text-white font-graphik font-[500] text-[15px] sm:text-[16px]">
            <span className="opacity-90 group-hover:opacity-100 transition-opacity">View Details</span>
            <ChevronRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

const SalesServicesOverview = () => {
  // Animation variants for the grid
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  return (
    <div className="min-h-screen">
      <WhoHero
        title={
          <>
            Global IT Consulting <br /> & Implementations
          </>
        }
        text="Explore our comprehensive ServiceNow consulting services across major business hubs worldwide. Select your region below to discover tailored solutions."
        imgData="/assets/what/img8.png"
      />

      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-20">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {servicesCard.map((service, index) => {
            return (
              <Link to={service?.slug} key={index} >
                <ServiceCard service={service} />
              </Link>
            )
          })}
          {/* {salesData.map((service, index) => {
            return (
              <motion.div key={index} variants={cardVariants} className="w-full">
                <Link to={service.slug} className="block group w-full h-[400px]">
                  <div className='relative flex flex-col h-full bg-white border border-[#01386A45] hover:shadow-xl transition-all duration-300 lg:p-[40px] p-[30px] overflow-hidden cursor-pointer'>
                    <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#01386A]"></div>
                    <div className="absolute bottom-0 left-0 w-0 h-[3px] bg-[#ED6800] group-hover:w-full transition-all duration-500 ease-out z-10"></div>
                    <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora leading-[1.3] mb-8 pr-4">
                      {service.hero.title}
                    </h3>
                    <div className="relative flex-1">
                      <p className="absolute inset-0 text-[#49577A] lg:text-[16px] text-[14px] leading-[1.8] font-graphik font-[500] opacity-0 translate-x-12 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-500 ease-out overflow-hidden line-clamp-6">
                        {service.empower.descriptions[0]}
                      </p>
                      <div className="absolute bottom-0 left-0 flex items-center gap-2 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                        <span className="text-[#0F3057] text-[15px] font-[600] font-graphik underline underline-offset-4 decoration-1 decoration-[#0F3057]">
                          View Details
                        </span>
                        <span className="text-[#F6821F] font-bold text-lg leading-none">
                          &gt;
                        </span>
                      </div>

                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })} */}
        </motion.div>
      </div>

    </div>
  );
};

export default SalesServicesOverview;
